<form id="form" [formGroup]="Form" autocomplete="off" (keyup.enter)="emit_submit()">
    <h2>Wijzig je e-mailadres.</h2>
    <p>
        Huidig e-mailadres: <strong>{{currentEmail$$() ?? '…'}}</strong><br>
        Je ontvangt een bevestigingslink op het nieuwe adres; pas na bevestiging is de wijziging actief.
    </p>
    <p>
        Na opslaan word je <strong>automatisch uitgelogd</strong>. Bevestig je nieuwe e-mailadres via de
        link in de e-mail en log daarna in met je nieuwe e-mailadres. Bevestig je niet, dan blijft je
        huidige e-mailadres gewoon geldig.
    </p>
    <app-input-control [htmlAutocomplete]="'email'"
        [autofocus]="true"
        [control]="FormControls.newEmail"
        [label]="'nieuw e-mailadres'"
        [lockOnLoad]="true"
        [placeholder]="'vul je nieuwe e-mailadres in'"
        [showError]="showErrors || Form.touched"
        [tabIndex]="'0'"
        [type]="'email'" />
</form>
